(function () {
	"use strict";

	const testimonialSliders = document.querySelectorAll(".testimonials-slider");

	testimonialSliders.forEach(sliderContainer => {
		// 🔎 Detect if inside trust section
		const trustSection = sliderContainer.closest(".trust-section");

		// Look for elements specifically inside THIS container
		const swiperElement = sliderContainer.querySelector(".swiper");
		let prevBtn = sliderContainer.querySelector(".prev-btn");
		let nextBtn = sliderContainer.querySelector(".next-btn");
		const pagination = sliderContainer.querySelector(".slider-pagination");
		// const prevBtn = sliderContainer.querySelector('.ic-chevron-left').parentElement;
		// const nextBtn = sliderContainer.querySelector('.ic-chevron-right').parentElement;

		if (!prevBtn || !nextBtn) {
			if (trustSection) {
				prevBtn = trustSection.querySelector(".section-title .slider-control .prev-btn");
				nextBtn = trustSection.querySelector(".section-title .slider-control .next-btn");
			}
		}

		const swiper = new Swiper(swiperElement, {
			// Basic Swiper settings
			slidesPerView: trustSection ? 1.13 : 1.3,
			spaceBetween: trustSection ? 20 : 28,
			// loop: true,

			// Navigation configuration
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
				disabledClass: "disabled",
				hiddenClass: "hidden",
				navigationDisabledClass: "navigation-disabled",
				lockClass: "lock"
			},
			pagination: {
				el: pagination,
				type: "bullets",
				clickable: true,
				bulletClass: "bullet-item",
				bulletActiveClass: "active"
			},

			// Responsive breakpoints (optional)
			breakpoints: {
				768: {
					slidesPerView: trustSection ? 1.13 : 1.3,
					spaceBetween: trustSection ? 20 : 28
				},
				811: {
					slidesPerView: trustSection ? 2.45 : 2,
					spaceBetween: trustSection ? 32 : 80
				}
			}
		});
	});

	const expertsSliders = document.querySelectorAll(".experts-slider");

	expertsSliders.forEach(sliderContainer => {
		// Look for elements specifically inside THIS container
		const swiperElement = sliderContainer.querySelector(".swiper");
		const prevBtn = sliderContainer.querySelector(".prev-btn");
		const nextBtn = sliderContainer.querySelector(".next-btn");
		const pagination = sliderContainer.querySelector(".slider-pagination");

		const swiper = new Swiper(swiperElement, {
			// Basic Swiper settings
			slidesPerView: 1.2,
			spaceBetween: 24,
			// loop: true,

			// Navigation configuration
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
				disabledClass: "disabled",
				hiddenClass: "hidden",
				navigationDisabledClass: "navigation-disabled",
				lockClass: "lock"
			},
			pagination: {
				el: pagination,
				type: "bullets",
				clickable: true,
				bulletClass: "bullet-item",
				bulletActiveClass: "active"
			},

			// Responsive breakpoints (optional)
			breakpoints: {
				768: {
					slidesPerView: 1.2
				},
				811: {
					spaceBetween: 36,
					slidesPerView: 2
				}
			}
		});
	});

	const shopSliders = document.querySelectorAll(".shop-slider");

	shopSliders.forEach(sliderContainer => {
		// Look for elements specifically inside THIS container
		const swiperElement = sliderContainer.querySelector(".swiper");
		const prevBtn = sliderContainer.closest(".shop-section").querySelector(".prev-btn");
		const nextBtn = sliderContainer.closest(".shop-section").querySelector(".next-btn");
		const pagination = sliderContainer.closest(".shop-section").querySelector(".slider-pagination");

		const swiper = new Swiper(swiperElement, {
			// Basic Swiper settings
			slidesPerView: 1.1,
			spaceBetween: 24,
			// loop: true,

			// Navigation configuration
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
				disabledClass: "disabled",
				hiddenClass: "hidden",
				navigationDisabledClass: "navigation-disabled",
				lockClass: "lock"
			},
			pagination: {
				el: pagination,
				type: "bullets",
				clickable: true,
				bulletClass: "bullet-item",
				bulletActiveClass: "active"
			},

			// Responsive breakpoints (optional)
			breakpoints: {
				768: {
					slidesPerView: 1.1
				},
				811: {
					slidesPerView: 3,
					spaceBetween: 36
				}
			}
		});
	});

	function initAcc(elem, option, active) {
		if (active === true) {
			let _item = document.querySelectorAll(elem);
			for (let i = 0; i < _item.length; i++) {
				let _parent = _item.item(i).querySelectorAll(".list-item");
				// let _content = _parent.item(0).querySelector('.content-box');
				_parent.item(0).classList.add("open");
			}
		}

		document.addEventListener("click", function (e) {
			if (!e.target.matches(elem + " .label-box")) return;
			else {
				let _parent = e.target.closest(".list-item");
				// let _content = _parent.querySelector('.content-box');

				if (!_parent.classList.contains("open")) {
					if (option === true) {
						let elementList = e.target.closest(elem).querySelectorAll(".list-item");
						Array.prototype.forEach.call(elementList, function (e) {
							e.classList.remove("open");
						});
					}
					_parent.classList.add("open");
				} else {
					_parent.classList.remove("open");
				}
			}
		});
	}

	initAcc(".faq-list", false, false);

	function initProgramBenefits() {
		const sections = document.querySelectorAll(".program-benefits");
		if (!sections.length) return; // no sections → safely exit

		function isMobile() {
			return window.matchMedia("(max-width: 810px)").matches;
		}

		sections.forEach(section => {
			const infoItems = section.querySelectorAll(".info-box ul li");
			const mediaItems = section.querySelectorAll(".media-box ul li");

			if (!infoItems.length || !mediaItems.length) return;

			infoItems.forEach((item, index) => {
				// 🔹 DESKTOP HOVER
				item.addEventListener("mouseenter", function () {
					if (isMobile()) return;
					if (this.classList.contains("active")) return;

					infoItems.forEach(el => el.classList.remove("active"));
					mediaItems.forEach(el => el.classList.remove("active"));

					this.classList.add("active");
					mediaItems[index].classList.add("active");
				});

				// 🔹 MOBILE CLICK
				item.addEventListener("click", function () {
					if (!isMobile()) return;

					this.classList.toggle("open");
					mediaItems[index].classList.toggle("open");
				});
			});
		});
	}

	initProgramBenefits();


    const storySections = document.querySelectorAll('.community-stories .column-wrap');

    if (storySections.length) {

        storySections.forEach(wrap => {
            const moreBtnContainer = wrap.nextElementSibling?.classList.contains('more-btn')
                ? wrap.nextElementSibling
                : wrap.parentElement.querySelector('.more-btn');

            if (!moreBtnContainer) return;
            const button = moreBtnContainer.querySelector('button');
            if (!button) return;

            const updateButtonVisibility = () => {
                const hiddenCards = wrap.querySelectorAll('.story-card:not(.is-visible)');
                if (hiddenCards.length === 0) {
                    moreBtnContainer.style.display = 'none';
                }
            };

            updateButtonVisibility();

            button.addEventListener('click', () => {
                const columns = wrap.querySelectorAll('.column-box');
                const columnCount = columns.length;
                if (columnCount === 0) return;

                // 1. Get the attribute value (defaults to 4 if missing/invalid)
                const attrItemsPerLoad = parseInt(wrap.getAttribute('data-items-per-load'), 10) || 4;

                // 2. Force the minimum value to be the number of columns
                const itemsPerLoad = Math.max(attrItemsPerLoad, columnCount);

                let cardsLoaded = 0;
                let currentColumnIndex = 0;
                const totalHidden = wrap.querySelectorAll('.story-card:not(.is-visible)').length;

                for (let i = 0; i < totalHidden; i++) {
                    if (cardsLoaded >= itemsPerLoad) break;

                    const targetColumn = columns[currentColumnIndex];
                    const hiddenCardInColumn = targetColumn.querySelector('.story-card:not(.is-visible)');

                    if (hiddenCardInColumn) {
                        hiddenCardInColumn.classList.add('is-visible');
                        cardsLoaded++;
                    }

                    currentColumnIndex = (currentColumnIndex + 1) % columnCount;
                }

                updateButtonVisibility();
            });
        });
    }

    
})();

//# sourceMappingURL=maps/common.js.map
